// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"93":"1bcfb219","488":"be6b5fee","603":"269242da","945":"d5dcef5b"}[chunkId] + ".chunk.js";
};